/**
 * Map validation issue patterns to actionable fix guidance.
 */
const HINTS = [
  {
    match: (issue) => issue.message?.includes('exclusion list'),
    hint: 'Remove this account from your source file, or ask Finance to confirm it should be added to the chart of accounts.',
  },
  {
    match: (issue) => issue.field === 'Balance' && issue.message?.includes('sum should be zero'),
    hint: 'iSolved GL reports should balance automatically. Check for missing rows or manual edits to amounts.',
  },
  {
    match: (issue) => issue.message?.includes('out of balance'),
    hint: 'Check that total debits equal total credits. Look for missing offsetting lines or sign errors.',
  },
  {
    match: (issue) => issue.field === 'account' && issue.message?.includes('empty'),
    hint: 'Every row needs a valid 4–6 digit account number. Remove blank rows from your spreadsheet.',
  },
  {
    match: (issue) => issue.field === 'unit' && issue.message?.includes('empty'),
    hint: 'Add the business unit (e.g. 80) for each row. This maps to the MV Unit column.',
  },
  {
    match: (issue) => issue.message?.includes("doesn't match expected format"),
    hint: 'Account numbers should be numeric only (e.g. 701180). Remove dashes, spaces, or text prefixes.',
  },
  {
    match: (issue) => issue.message?.includes('Non-numeric'),
    hint: 'Remove currency symbols ($), commas, and parentheses from amount cells. Use plain numbers like 16800 or 16800.00.',
  },
  {
    match: (issue) => issue.field === 'amount' && issue.message?.includes('empty'),
    hint: 'Payroll rows need an amount. Use positive for debits and negative for credits.',
  },
];

export function getFixHint(issue) {
  const match = HINTS.find((h) => h.match(issue));
  return match?.hint ?? null;
}
